import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { clearVoucher, setVoucher } from "store/apps/price";

export default function useCheckoutVoucher() {
  const dispatch = useDispatch();

  const { voucher } = useSelector((state: RootState) => state.price);

  const _onSelectVoucher = (voucher: any, appliedCount: number) => {
    dispatch(
      setVoucher({
        voucher: voucher,
        appliedCount: appliedCount,
      })
    );
  };

  const _onClearVoucher = () => {
    dispatch(clearVoucher(null));
  };

  return { voucher, _onSelectVoucher, _onClearVoucher };
}
